import {
  axiosGetNewToken
} from "@/api/auth";
const config = {
  config: "config",
  url: window.url,
  imgUrl: window.url,
  adminName: window.adminName,
  nameColors: {
    "0类": "rgba(252, 202, 82, 1)",
    "1类": "rgba(160, 230, 158, 1)",
    "2类": "rgba(97, 171, 255, 1)",
    "3类": "rgba(194, 105, 60, 1)",
    "4a类": "rgba(255, 89, 64, 1)",
    "4b类": "rgba(204, 69, 202, 1)",
  },
  nameColorsFunc: (v) => {
    const colors = {
      "0类": "rgba(252, 202, 82, 1)",
      "1类": "rgba(160, 230, 158, 1)",
      "2类": "rgba(97, 171, 255, 1)",
      "3类": "rgba(194, 105, 60, 1)",
      "4a类": "rgba(255, 89, 64, 1)",
      "4b类": "rgba(204, 69, 202, 1)",
    }
    let val = ''
    for (let key in colors) {
      if (v.indexOf(key) > -1 || v == key) {
        val = colors[key]
        break
      }
    }
    return val
  },
  reg: (v) => {
    return ('' + v).split(/<[^>]+>/gim).join("").split('').join("")
  },
  getArrKeys: (arr, k1, k2) => {
    let s = []
    arr.map(v => {
      s.push(`${v[k1]}${v[k2]?'('+v[k2]+')':''}`)
    })
    return s
  },
  setWind: (v) => {
    if (v >= 337.5 || v <= 22.25) return '北风'
    if (v >= 22.25 && v <= 67.5) return '东北风'
    if (v >= 67.5 && v <= 112.5) return '东风'
    if (v >= 112.5 && v <= 157.5) return '东南风'
    if (v >= 157.5 && v <= 202.5) return '南风'
    if (v >= 202.5 && v <= 247.5) return '西南风'
    if (v >= 247.5 && v <= 292.5) return '西风'
    if (v >= 292.5 && v <= 337.5) return '西北风'
  },
  settingElTable: (that, h) => {
    that.tableHeight = window.innerHeight - 144 - 70 - (h || 0);
    if (that.needPages) that.tableHeight = that.tableHeight - 40;
    that.tableSize = Math.floor((that.tableHeight - 40 * 1) / 40);
    that.pageSize = that.tableSize;
    window.addEventListener("resize", () => {
      that.tableHeight = window.innerHeight - 144 - 70 - (h || 0);
      if (that.needPages) {
        that.tableHeight = that.tableHeight - 40;
      }
      that.tableSize = Math.floor((that.tableHeight - 40 * 1) / 40);
      that.pageSize = that.tableSize;
    });
  },
  dataStr: (value, title) => {
    if (value === null || value === '' || value === undefined) {
      return '-'
    } else {
      if (title) {
        if (title.indexOf('率') > -1) {
          return (+value).toFixed(2) + '%'
        }
        return value
      } else {
        return value
      }
    }
  },
  chartColors: [
    "rgb(17, 130, 251)",
    "rgba(103, 207, 181, 1)",
    "rgba(255, 141, 26, 1)",
    "rgba(189, 214, 0, 1)",
    "rgba(210, 0, 64, 1)",
    "rgba(207, 103, 205, 1)",
    "rgba(92, 14, 227, 1)",
    "rgba(98, 209, 63, 1)",
    "rgba(135, 72, 72, 1)",
  ],
  levelColor: {
    '无效': '#999',
    '优': "#62D13F",
    '良': "#F5CB2A",
    '轻度污染': "#FF7E00",
    '轻度': "#FF7E00",
    '中度污染': "#FF401A",
    '中度': "#FF401A",
    '重度污染': "#D20040",
    '重度': "#D20040",
    '严重污染': "#9C0A4E",
    '严重': "#9C0A4E",
    'bg无效': 'rgba(153,153,153,.2)',
    'bg优': 'rgba(98,209,63,.2)',
    'bg良': "rgba(245,203,42,.2)",
    'bg轻度污染': 'rgba(255,126,0,.2)',
    'bg轻度': 'rgba(255,126,0,.2)',
    'bg中度污染': 'rgba(255,64,26,.2)',
    'bg中度': 'rgba(255,64,26,.2)',
    'bg重度污染': 'rgba(210,0,64,.2)',
    'bg重度': 'rgba(210,0,64,.2)',
    'bg严重污染': 'rgba(156,10,78,.2)',
    'bg严重': 'rgba(156,10,78,.2)',
  },
  rank: (property) => {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value2 - value1;
    }
  },
  getWeekDay: (day) => {
    let date = new Date(day)
    var weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return weekDay[date.getDay()]
  },
  // 字符串截取
  strSlice: (txt, num, ellipsis = true) => txt.length > num ? txt.slice(0, num) + (ellipsis ? '...' : '') : txt,
  // 刷新token
  getNewToken(_this, requestFunc) {
    axiosGetNewToken({
      token: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).refreshToken : ''
    }).then(res => {
      if (typeof requestFunc === 'function' && !requestFunc) {
        alert('_this指向错误')
      }
      if (!_this) {
        window.location.replace()
      }
      // window.resTokenKey = 0
      if (_this.$route.path != '/login') {
        if (res.result == '') {
          // _this.$message({
          //   message: "登录状态已过期，即将跳转重新登陆",
          //   type: "info",
          //   duration: 1000,
          // });
          localStorage.removeItem("token")
          localStorage.removeItem("userInfo")
          setTimeout(() => {
            _this.$router.push({
              path: "/login"
            });
          }, 1000)
        } else {
          //重新获取token
          localStorage.setItem("token", res.result); //重置token
          requestFunc()
        }
      }
    })
  },
  // 导出文件公共方法
  exportData(_this, fileName) {
    _this.exportFlag = false
    setTimeout(() => {
      let excelName = `${fileName}.xlsx`;
      var xlsxParam = {
        raw: true
      }; //转换成excel时，使用原始的格式
      // 克隆节点
      // let tables = document.getElementById("out-table").cloneNode(true);
      // let tables = document.getElementsByClassName('el-table')[0].cloneNode(true);
      let tables = _this.$refs.exportTable.cloneNode(true);
      // 判断是否为固定列，解决（为固定列时，会重复生成表格）
      let table_book = _this.$XLSX.utils.table_to_book(tables, xlsxParam);
      var table_write = _this.$XLSX.write(table_book, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        _this.$FileSaver.saveAs(
          new Blob([table_write], {
            type: "application/octet-stream"
          }),
          excelName
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, table_write);
      }
      setTimeout(() => {
        _this.$store.dispatch('store/setLoading', false)
        _this.exportFlag = true
      }, 100);
    });
  },
  getLevel: (classify, type, time, num) => {
    if (num == '' || num == null || isNaN(+num)) {
      return {
        level: "-",
        color: "#999",
        background: 'rgba(153,153,153,.2)',
        type,
        value: num
      }
    }
    // classify 大气  水质
    // type 数值类型
    // time 是否区分1或者24小时  不区分传 ''
    // num  数字
    type == 'PM25' ? type = 'PM2.5' : ''
    let reg = /<[^>]+>/gim;
    if (type) type = type.split(reg).join('');
    type == 'AQI/综指' ? type = 'AQI' : type
    let isTime = ''
    if (time == '时' || time == '实时') {
      isTime = 1
    } else {
      isTime = 24
    }
    const classObj = {
      '大气': {
        'AQI': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 50
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 50,
            max: 100
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 100,
            max: 150
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 150,
            max: 200
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 200,
            max: 300
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 300,
            max: null
          }
        ],
        'PM2.5': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 35
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 35,
            max: 75
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 75,
            max: 115
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 115,
            max: 150
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 150,
            max: 250
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 250,
            max: null
          }
        ],
        'PM10': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 50
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 50,
            max: 150
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 150,
            max: 250
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 250,
            max: 350
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 350,
            max: 420
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 420,
            max: null
          }
        ],
        'SO2-1': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 150
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 150,
            max: 500
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 500,
            max: 650
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 650,
            max: 800
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 800,
            max: null
          },
        ],
        'SO2-24': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 50
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 50,
            max: 150
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 150,
            max: 475
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 475,
            max: 800
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 800,
            max: 1600
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 1600,
            max: null
          }
        ],
        'NO2-1': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 100
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 100,
            max: 200
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 200,
            max: 700
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 700,
            max: 1200
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 1200,
            max: 2340
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 2340,
            max: null
          }
        ],
        'NO2-24': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 40
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 40,
            max: 80
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 80,
            max: 180
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 180,
            max: 280
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 280,
            max: 565
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 565,
            max: null
          }
        ],
        'CO-1': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 5
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 5,
            max: 10
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 10,
            max: 35
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 35,
            max: 60
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 60,
            max: 90
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 90,
            max: null
          }
        ],
        'CO-24': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 2
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 2,
            max: 4
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 4,
            max: 14
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 14,
            max: 24
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 24,
            max: 36
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 36,
            max: null
          }
        ],
        'O3-1': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 100
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 100,
            max: 160
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 160,
            max: 215
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 215,
            max: 265
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 265,
            max: 800
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 800,
            max: null
          }
        ],
        'O3-24': [{
            level: "优",
            color: "#62D13F",
            background: 'rgba(98,209,63,.2)',
            min: 0,
            max: 160
          },
          {
            level: "良",
            color: "#F5CB2A",
            background: "rgba(245,203,42,.2)",
            min: 160,
            max: 200
          },
          {
            level: "轻度污染",
            color: "#FF7E00",
            background: 'rgba(255,126,0,.2)',
            min: 200,
            max: 300
          },
          {
            level: "中度污染",
            color: "#FF401A",
            background: 'rgba(255,64,26,.2)',
            min: 300,
            max: 400
          },
          {
            level: "重度污染",
            color: "#D20040",
            background: 'rgba(210,0,64,.2)',
            min: 400,
            max: 800
          },
          {
            level: "严重污染",
            color: "#9C0A4E",
            background: 'rgba(156,10,78,.2)',
            min: 800,
            max: null
          }
        ],
      },
      '水质': {
        '高锰酸盐指数': [{
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 0,
            max: 2
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 2,
            max: 4
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 4,
            max: 6
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 6,
            max: 10
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 10,
            max: 15
          },
          {
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 15,
            max: null
          },
        ],
        '化学需氧量(COD)': [{
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 0,
            max: 15
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 15,
            max: 15
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 15,
            max: 20
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 20,
            max: 30
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 30,
            max: 40
          },
          {
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 15,
            max: null
          },
        ],
        '氨氮': [{
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 0,
            max: 0.15
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 0.15,
            max: 0.5
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 0.5,
            max: 1
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 1,
            max: 1.5
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 1.5,
            max: 2
          },
          {
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 2,
            max: null
          },
        ],
        '总磷': [{
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 0,
            max: 0.02
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 0.02,
            max: 0.1
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 0.1,
            max: 0.2
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 0.2,
            max: 0.3
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 0.3,
            max: 0.4
          },
          {
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 0.4,
            max: null
          },
        ],
        '总氮': [{
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 0,
            max: 0.2
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 0.2,
            max: 0.5
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 0.5,
            max: 1
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 1,
            max: 1.5
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 1.5,
            max: 2
          },
          {
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 2,
            max: null
          },
        ],
        '溶解氧': [{
            level: "劣Ⅴ类",
            color: "#ff0000",
            background: 'rgba(255,0,0,.2)',
            min: 0,
            max: 2
          },
          {
            level: "Ⅴ类",
            color: "#FF9B00",
            background: 'rgba(255,155,0,.2)',
            min: 2,
            max: 3
          },
          {
            level: "Ⅳ类",
            color: "#FFFF00",
            background: 'rgba(255,255,0,.2)',
            min: 3,
            max: 5
          },
          {
            level: "Ⅲ类",
            color: "#00FF00",
            background: 'rgba(0,255,0,.2)',
            min: 5,
            max: 6
          },
          {
            level: "Ⅱ类",
            color: "#00CCFF",
            background: 'rgba(0,204,255,.2)',
            min: 6,
            max: 7.5
          },
          {
            level: "Ⅰ类",
            color: "#CCFFFF",
            background: 'rgba(204,255,255,.2)',
            min: 7.5,
            max: null
          },
        ],
      }
    }

    if (type != 'pH') {
      let arr = null
      if (type == 'SO2' || type == 'NO2' || type == 'CO' || type == 'O3') {
        arr = classObj[classify][type + '-' + isTime]
      } else {
        arr = classObj[classify][type]
      }
      let item = {}
      for (let i in arr) {
        if (arr[i].max == null) {
          item = arr[i]
          break
        } else if (arr[i].max != null && +num > arr[i].min && num <= arr[i].max) {
          item = arr[i]
          break
        }
      }
      item.value = num
      item.type = type
      return item
    } else if (type == 'pH') {
      return {
        level: num >= 6 && num <= 9 ? 'Ⅰ' : "劣Ⅴ",
        color: num >= 6 && num <= 9 ? '#CCFFFF' : "#ff0000",
        background: num >= 6 && num <= 9 ? 'rgba(204,255,255,.2)' : "rgba(255,0,0,.2)",
        value: num,
        type
      }
    }
  },
};
export default config;



// WEBPACK FOOTER //
// ./src/util/config.js